import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';
import './glitch.css';
import './responsive.css';
import './effects.css';
import './components/TerminalContact.css';
import './cosmic.css';
import './brutalist.css';
import './sunset.css';
import './swiss.css';
import './museum.css';
import './manuscript.css';
import './refinements.css';
import './paintwash.css';
import './components/LectureTrackerLink.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
